package ru.arty_bikini.crm.dto.packet.order_stone

import kotlinx.serialization.Serializable

@Serializable
class SaveResponse(
    val status: String
    )